import { Injectable } from '@angular/core';

// Models
import { MetaData, ResponseData } from 'src/app/platform/models/utils';

// Services
import { UserService } from 'src/app/modules/account/user.service';
import { ApiService } from 'src/app/platform/services/api.service';

/**
 * This class obtains geolocation data
 */
@Injectable({
    providedIn: 'root'
})
export class GeodataService {
    constructor(
        private apiService: ApiService,
        private userService: UserService
    ) { }

    /**
     * Get a list of states
     */
    statesGet(): Promise<ResponseData>{
        return new Promise((resolve, reject) => {
            const headers = {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer ' + this.userService.currentUser.value.token
            };

            this.apiService.request('get', 'datosgeograficos/provincias', {}, headers).toPromise().then((success: any) => {
                if (success.response.status) {
                    const metaData: Array<MetaData> = [];

                    success.items.forEach((value: any, index: number) => {
                        metaData.push(new MetaData().configData(value));
                    });

                    resolve(this.apiService.successDataPrepare('', metaData));
                } else{
                    reject(this.apiService.errorDataPrepare(success.response.message, success));
                }
           }, (error) => {
             reject(this.apiService.errorDataPrepare(error.response.message, error));
           });
        });
    }

    /**
     * Get a list of departments
     */
    departmentsGet(state: number): Promise<ResponseData>{
        return new Promise((resolve, reject) => {
            const headers = {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer ' + this.userService.currentUser.value.token
            };

            this.apiService.request('get', 'datosgeograficos/provincias/' + state + '/departamentos', {}, headers).toPromise().then((success: any) => {
                if (success.response.status) {
                    const metaData: Array<MetaData> = [];

                    success.items.forEach((value: any, index: number) => {
                        metaData.push(new MetaData().configData(value));
                    });

                    resolve(this.apiService.successDataPrepare('', metaData));
                } else{
                    reject(this.apiService.errorDataPrepare(success.response.message, success));
                }
           }, (error) => {
             reject(this.apiService.errorDataPrepare(error.response.message, error));
           });
        });
    }

    /**
     * Get a list of cities
     */
    citiesGet(state: number, department: number): Promise<ResponseData>{
        return new Promise((resolve, reject) => {
            const headers = {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer ' + this.userService.currentUser.value.token
            };

            this.apiService.request('get', 'datosgeograficos/provincias/' + state + '/departamentos/' + department + '/localidades', {}, headers).toPromise().then((success: any) => {
                if (success.response.status) {
                    const metaData: Array<MetaData> = [];

                    success.items.forEach((value: any, index: number) => {
                        metaData.push(new MetaData().configData(value));
                    });

                    resolve(this.apiService.successDataPrepare('', metaData));
                } else{
                    reject(this.apiService.errorDataPrepare(success.response.message, success));
                }
           }, (error) => {
             reject(this.apiService.errorDataPrepare(error.response.message, error));
           });
        });
    }

    /**
     * Get a list of streets according to a search
     */
    streetsGet(query: string, state: number): Promise<ResponseData>{
        return new Promise((resolve, reject) => {
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.userService.currentUser.value.token
            };

            this.apiService.request('get', 'datosgeograficos/provincias/' + state + '/calles?search=' + query + '&page=1&limit=100', {}, headers).toPromise().then((success: any) => {
                if (success.response.status) {
                    const metaData: Array<MetaData> = [];

                    success.items.forEach((value: any, index: number) => {
                        metaData.push(new MetaData().configData(value));
                    });

                    resolve(this.apiService.successDataPrepare('', metaData));
                } else{
                    reject(this.apiService.errorDataPrepare(success.response.message, success));
                }
           }, (error) => {
             reject(this.apiService.errorDataPrepare(error.response.message, error));
           });
        });
    }
}
